export const ShapeType = {
  TRIANGLE: 'triangle',
  STAR: 'star',
  ARROW_4: 'arrow4points',
  ARROW_6: 'arrow6points',
};

export default { ShapeType };
